var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('ContentBlock',{attrs:{"breadcrumbs-title":_vm.videoData ? _vm.videoData.title : '',"breadcrumbs-list":_vm.breadcrumbs,"data":_vm.videoData,"type":_vm.BLOG_CONTENT_TYPE.VIDEO}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }